import React, { useEffect, useRef } from 'react';
import LinkTable from '@/creditflowresearch/ui/common/components/LinkTable';
import { useLeagueTableContext } from '@/creditflowresearch/application/League/Table/LeagueTableContext';

const AllCompaniesTable = (props) => {
  const didMount = useRef(false);
  const {
    state,
    paginateCompaniesAll,
    itemsPerPageCompaniesAll,
    getCompaniesAllByFilter,
  } = useLeagueTableContext();
  const { page, perPage } = state.companiesAllCollection;

  const onPageChange = (page) => {
    paginateCompaniesAll(page.selected);
  };

  const onItemsPerPageChange = (perPage) => {
    itemsPerPageCompaniesAll(perPage.value);
  };

  useEffect(() => {
    if (didMount.current) {
      getCompaniesAllByFilter();
    } else {
      didMount.current = true;
    }
  }, [page, perPage]);

  return (
    <LinkTable
      { ...props }
      { ...state.companiesAllCollection }
      onPageChange={ onPageChange }
      onItemsPerPageChange={ onItemsPerPageChange }
    />
  );
};

export default AllCompaniesTable;
